import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

const AppWrapper = (
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap: if pre-rendered HTML exists, hydrate instead of full render
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, AppWrapper);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppWrapper);
}
